export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    LOGIN_WITH_MAGIC_CODE: "/auth/login/magic-auth-code",
    LOGIN_WITH_ORGANIZATIONS_SELECTION: "/auth/login/organization-selection",
    FORGOT_PASSWORD: "/auth/password-reset",
    MIGRATION_PROCESS: "/auth/migration-process",
    MIGRATION_STATUS: "/auth/migration-status",
    EXCHANGE_CODE: "/auth/exchange-code",
    LOGOUT_SESSION: "/auth/logout-session",
  }
};